import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, mergeProps as _mergeProps, toHandlers as _toHandlers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/suitcase-outline-black.svg'
import _imports_1 from '@/assets/img/icon/check-circle-green.svg'


const _hoisted_1 = { class: "content mt-16 mb-4 px-4" }
const _hoisted_2 = { class: "flex items-top gap-4 justify-between py-30px px-4" }
const _hoisted_3 = { class: "flex items-top gap-4" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "text-xl font-bold" }
const _hoisted_6 = { class: "text-lg font-semibold mb-1" }
const _hoisted_7 = { class: "flex items-center mb-1" }
const _hoisted_8 = { class: "text-grey-5 text-base" }
const _hoisted_9 = { class: "text-grey-5 text-base" }
const _hoisted_10 = { class: "text-grey-5 text-base mb-1" }
const _hoisted_11 = { class: "text-grey-5 text-base" }
const _hoisted_12 = {
  key: 0,
  class: "grid grid-cols-11 gap-8 ml-min"
}
const _hoisted_13 = { class: "col-span-1 pt-6" }
const _hoisted_14 = { class: "icon-number float-right" }
const _hoisted_15 = { class: "icon_item mb-8" }
const _hoisted_16 = { class: "icon_circle" }
const _hoisted_17 = { class: "icon_number" }
const _hoisted_18 = { class: "col-span-2" }
const _hoisted_19 = { class: "mt-6" }
const _hoisted_20 = { class: "w-full rounded-lg border-grey-4 background-grey-3 py-8px px-16px" }
const _hoisted_21 = { class: "col-span-2" }
const _hoisted_22 = { class: "mt-6" }
const _hoisted_23 = { class: "mb-4" }
const _hoisted_24 = {
  key: 0,
  class: "text-xs text-red"
}
const _hoisted_25 = { class: "invalid-feedback" }
const _hoisted_26 = { class: "col-span-2" }
const _hoisted_27 = { class: "mt-6" }
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = {
  key: 0,
  class: "text-xs text-red"
}
const _hoisted_30 = { class: "invalid-feedback" }
const _hoisted_31 = { class: "col-span-2" }
const _hoisted_32 = { class: "mt-6" }
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = {
  key: 0,
  class: "text-xs text-red"
}
const _hoisted_35 = { class: "invalid-feedback" }
const _hoisted_36 = { class: "col-span-2" }
const _hoisted_37 = { class: "mt-6" }
const _hoisted_38 = { class: "mb-4" }
const _hoisted_39 = { class: "flex" }
const _hoisted_40 = { class: "flex-none" }
const _hoisted_41 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_42 = {
  key: 0,
  class: "grid grid-cols-4 gap-1 py-2"
}
const _hoisted_43 = { class: "col-span-3" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "col-span-1" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "flex mt-auto float-right pt-16" }

import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'
import { DatePicker } from 'v-calendar'
import * as Yup from 'yup'
import { Form, Field } from 'vee-validate'
import { computed, getCurrentInstance, isRuntimeOnly, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiUseCase from '@/usecase/apiUseCase'
import rgxExp from '@/utils/helpers/regExp'
import apiImageUseCase from '@/usecase/apiImageUseCase'
import environment from '@/configs/environtment'
import moment from 'moment'
import { useRoute } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { x64 } from 'crypto-js'
import { data } from 'jquery'

const moduleStore = 'hjpTable'
const employeeEndpoint = 'talent/v1/employees'
const employmentEndpoint = 'talent/v1/employments'
const employeeDocumentBulkEndpoint = 'documents/bulk'
const positionEndpoint = 'talent/v1/positions'
const documentRequirementsEndpoint = 'documentRequirements'
const maxSizeFile = 1024 * 1024 * 1
const photoKTP: any = 1
const photoKK: any = 2
const photoSIM: any = 3
const photoBPJS: any = 4

export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeDocumentForm',
  setup(__props) {

const store = useStore()
const route = useRoute()
const tempImgProfile = ref<any | null>(null)
const employeeId = ref()
const dataFormKTP = ref()
const dataFormKK = ref()
const dataFormSIM = ref()
const dataFormBPJS = ref()
const allDataForm = ref()
const dataFormContract = ref(store.getters['employee/getEmployeeContract'])
const contract = ref(store.getters['employee/getEmployeeContractLabel'])
const isDocumentRequirementEmpty = ref(false)
const idPrams = ref(null) as any
const isLoading = ref(true)
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const toast = (status: any, message: any) => {
  $toast.add({
    severity: status,
    detail: message,
    group: 'bc',
    closable: false,
    life: 3000
  })
}
const ErrorDocumentNumber = ref([]) as any
const uploadFileTemp = ref([]) as any
const errorCount = ref(0)
const deleteObj = ref([]) as any

const initialValues = {
  Fullname: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.name : '',
  PersonelNumber: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.personelNumber : '',
  BirthPlace: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.birthPlace : '',
  DateOfBirth: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.birthDate : null,
  JoinDate: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.joinDate : null,
  PhoneNumber: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.phoneNumber : null,
  Address: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.address : null,
  KTPdocNumber: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.KTPdocNumber : null,
  IsEmployeeActive: false,
  IssuedDates: [],
  ExpirationDates: [],
  DocumentFiles: [],
  // Description: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.description : '',
  // IsActive: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.IsActive : true
}

const dataForm = ref([
  // { id: idPrams.value?.id, documentNumber: '', issuedDate: '', expirationDate: '', file: '', disabled: false }
]) as any
// dataForm.value = [{ id: idPrams.value?.id, fullName: '', relationship: '', phoneNumber: '', remarks: '', disabled: false }]
const dataFormSubmit = ref([]) as any

const addField = () => {
  dataForm.value.push({ id: idPrams.value?.id, documentNumber: '', issuedDate: '', expirationDate: '', file: '', disabled: false })
}

const countDiffDate = (startDate: string, endDate: string) => {
  const start = moment(startDate)
  const end = moment(endDate)

  const years = end.diff(start, 'years')
  const afterYears = start.clone().add(years, 'years')

  const months = end.diff(afterYears, 'months')
  const afterMonths = afterYears.clone().add(months, 'months')

  const days = end.diff(afterMonths, 'days')

  console.log([years, afterYears, months, afterMonths, days])
  const parts = []
  if (years > 0) parts.push(`${years} tahun`)
  if (months > 0) parts.push(`${months} bulan`)
  if (days > 0) parts.push(`${days} hari`)

  return parts.join(' ') || '0 hari'
}

const schema = Yup.object().shape({
  // KTPDocNumber: Yup.string()
  //   .required('Nomor KTP tidak boleh kosong')
  //   .length(16, 'Nomor KTP harus 16 digit')
  //   .matches(rgxExp.KTP, 'Masukkan Nomor KTP yang valid'),
  // KKDocNumber: Yup.string()
  //   .required('Nomor KK tidak boleh kosong')
  //   .length(16, 'Nomor KK harus 16 digit')
  //   .matches(rgxExp.KK, 'Masukkan Nomor KK yang valid'),
  // SIMDocNumber: Yup.string()
  //   .required('Nomor SIM tidak boleh kosong')
  //   .length(14, 'Nomor SIM harus 14 digit')
  //   .matches(rgxExp.SIM, 'Masukkan Nomor KK yang valid'),
  // BPJSDocNumber: Yup.string()
  //   .required('Nomor BPJS tidak boleh kosong')
  //   .max(13, 'Nomor BPJS max 13 digit')
  //   .matches(rgxExp.BPJS, 'Masukkan Nomor BPJS yang valid'),
  // KTPIssuedDate: Yup.string()
  //   .required('Tanggal Dikeluarkan KTP tidak boleh kosong'),
  // KKIssuedDate: Yup.string()
  //   .required('Tanggal Dikeluarkan KK tidak boleh kosong'),
  // SIMIssuedDate: Yup.string()
  //   .required('Tanggal Dikeluarkan SIM tidak boleh kosong'),
  // BPJSIssuedDate: Yup.string()
  //   .required('Tanggal Dikeluarkan BPJS tidak boleh kosong'),
  // KTPExpirationDate: Yup.string()
  //   .required('Tanggal Kadaluarsa KTP tidak boleh kosong'),
  // KKExpirationDate: Yup.string()
  //   .required('Tanggal Kadaluarsa KK tidak boleh kosong'),
  // SIMExpirationDate: Yup.string()
  //   .required('Tanggal Kadaluarsa SIM tidak boleh kosong'),
  // BPJSExpirationDate: Yup.string()
  //   .required('Tanggal Kadaluarsa BPJS tidak boleh kosong'),
})

const onInputFile = (file: any, typeUpload: any, setFieldValue: any, x: any) => {
  /* eslint-disable */
  if (file) {
    const totalSize: number = Number((file.size / 1024 / 1024).toFixed(1))
    if (totalSize > 1) {
      toast('error', 'Ukuran file lebih dari 1MB.')
    } else {
      /* eslint-disable-next-line */
      console.log('typeUpload', typeUpload)
      console.log('xxxx', x)
      if (file) {
        // if (typeUpload === photoKTP) {
        // tempImgProfile.value = file.blob
        x.file = { file: file.file, name: file.name, blob: file.blob }
        // x.fileUrl = file.name
        //   setFieldValue('KTPPhoto', { file: file.file, name: file.name, blob: file.blob })
        // }
        // else if (typeUpload === photoKK) {
        //   // tempImgProfile.value = file.blob
        //   setFieldValue('KKPhoto', { file: file.file, name: file.name, blob: file.blob })
        // }
        // else if (typeUpload === photoSIM) {
        //   // tempImgProfile.value = file.blob
        //   setFieldValue('SIMPhoto', { file: file.file, name: file.name, blob: file.blob })
        // }
        // else if (typeUpload === photoBPJS) {
        //   // tempImgProfile.value = file.blob
        //   setFieldValue('BPJSPhoto', { file: file.file, name: file.name, blob: file.blob })
        // }
      }
    }
  }
}
const onDateInput = (event: any, row: any, fieldKey: string, formKey: string, setFieldValue: any) => {
  const val = event?.target?.value ?? event
  if (typeof val === 'string' && val.trim().length >= 8) {
    const parsed = moment(val.trim(), ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD'], true)
    if (parsed.isValid()) {
      row[fieldKey] = parsed.toDate()
      if (setFieldValue && formKey) setFieldValue(formKey, parsed.format('YYYY-MM-DD'))
    }
  }
}

const onDateChange = (event: any, row: any, fieldKey: string, formKey: string, setFieldValue: any) => {
  const val = event?.target?.value ?? event
  if (typeof val === 'string' && val.trim()) {
    const parsed = moment(val.trim(), ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD'], true)
    if (parsed.isValid()) {
      row[fieldKey] = parsed.toDate()
      if (setFieldValue && formKey) setFieldValue(formKey, parsed.format('YYYY-MM-DD'))
    }
  } else if (!val) {
    row[fieldKey] = null
    if (setFieldValue && formKey) setFieldValue(formKey, null)
  }
}

const processUpload: string | null | any = async (file: any) => {
  const payload = new FormData()
  payload.append('file', file)
  payload.append('SpecialPath', 'document')
  console.log('payload', payload)
  const response = await apiImageUseCase.postOrPut('api/v1/assets', null, payload)
  console.log('response', response)
  if (!response.error) {
    return response.result.path
  } else if (response.code === 401) {
    // refresh token & hit again
    store.dispatch('refreshToken')
    return
  }
  return null
}

const onBack = () => {
  console.log('back')
}

const openDetailImg = (fileUrl: string) => {
  window.open(fileUrl, '_blank')
}

const submitEmployeeSalary = async (contractId: string) => {
  // Implementation for submitting employee salary
  const payload = {
    baseSalary: dataFormContract.value.baseSalary,
    paymentDay: dataFormContract.value.paymentDay,
  }
  const response = await apiUseCase.putWithNoId(`${employmentEndpoint}/${contractId}/salary`, payload)
  if (!response.error) {
    toast('success', 'Berhasil menyimpan Data Gaji Karyawan')
    store.dispatch('employee/setEmployeeFormStep', 4)
  } else {
    toast('error', 'Gagal menyimpan Data Gaji Karyawan')
  }
  store.dispatch('hideLoading')
}

const submitEmployeeContract = async () => {
  const payload = {
    employeeId: dataFormContract.value.employeeId,
    employmentTypeId: dataFormContract.value.employmentTypeId,
    positionId: dataFormContract.value.positionId,
    regionId: dataFormContract.value.regionId,
    buildingId: dataFormContract.value.buildingId,
    startDate: moment(dataFormContract.value.startDate).format('YYYY-MM-DD'),
    endDate: dataFormContract.value.endDate ? moment(dataFormContract.value.endDate).format('YYYY-MM-DD') : null,
    remarks: dataFormContract.value.remarks ? dataFormContract.value.remarks : '',
    isActive: dataFormContract.value.isActive,
  }
  const response = await apiUseCase.postOrPut(employmentEndpoint, null, payload)
  console.log('response', response)
    if (!response.error) {
      toast('success', 'Berhasil menyimpan Data Kontrak Divisi')
      if (dataFormContract.value.baseSalary && dataFormContract.value.paymentDay) {
        await submitEmployeeSalary(response.result.id)
      } else {
        store.dispatch('employee/setEmployeeFormStep', 4)
      }
      // store.dispatch('employee/setEmployeeFormStep', 4)
    } else {
      toast('error', 'Gagal menyimpan Data Kontrak Divisi')
      store.dispatch('hideLoading')
    }
}

const processSubmit = async () => {
  console.log('errorCount', errorCount.value)

  const documentRequiredCount = dataForm.value.filter((x: any) => x.isRequired)
  const filledDocumentRequiredCount = dataForm.value.filter((x: any) => x.isRequired && x.issuedDate)
  const hasExpDocumentCount = documentRequiredCount.filter((x: any) => x.documentTypeReminderDaysBeforeExpiry)
  const filledHasExpDocumentCount = documentRequiredCount.filter((x: any) => x.documentTypeReminderDaysBeforeExpiry && x.expirationDate)

  console.log('xxx', [documentRequiredCount, filledDocumentRequiredCount, hasExpDocumentCount, filledHasExpDocumentCount])
  
  
  // if (errorCount.value === 0) {
  if (documentRequiredCount.length !== 0 && (documentRequiredCount.length === filledDocumentRequiredCount.length && hasExpDocumentCount.length === filledHasExpDocumentCount.length)) {
    store.dispatch('showLoading')

    // console.log('deletee', deleteObj.value)

    // dataFormSubmit.value = dataForm.value.filter((item: any, index: number) => index !== deleteObj.value(index))

    // dataFormSubmit.value = dataForm.value
    // dataFormSubmit.value = JSON.parse(JSON.stringify(dataForm.value))

    // dataFormSubmit.value = [...dataForm.value]
    dataFormSubmit.value = []
    dataForm.value.map((data: any) => {
      if (data?.issuedDate) {
        const obj = {
          ...data,
          documentNumber: data.documentNumber,
          file: data?.file ?? null,
          documentTypeId: data.documentTypeId,
          issuedDate: data.issuedDate ? moment(data.issuedDate, ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD') : null,
          expirationDate: data.expirationDate ? moment(data.expirationDate, ['DD/MM/YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD') : null,
          remarks: '-'
        }
        dataFormSubmit.value.push(obj)
      }
    })

    // console.log('dataFORMSUBMIT', dataFormSubmit.value)

    for (let i = 0; i < deleteObj.value.length; i++) {
      dataFormSubmit.value.splice(deleteObj.value[i], 1)
      // dataFormSubmit.value.slice(0, deleteObj.value[i])
      // dataFormSubmit.value = dataForm.value.filter((item: any, index: number) => index === deleteObj.value[i])
      // console.log('delLLOBJ>>>>', deleteObj.value[i])
    }

    // console.log('dataForm>>>>', dataForm.value)
    // console.log(' SUBMIT', dataFormSubmit.value)
    // console.log(' dataForm BIASA', dataForm.value)

    
    // try{
    //   let iDate
    //   let eDate
    //   let strSplit
    //   for (let i = 0; i < dataFormSubmit.value.length; i++) {
    //     iDate = dataFormSubmit.value[i].issuedDate
    //     eDate = dataFormSubmit.value[i].expirationDate
        
    //     if (dataForm.value.some((obj: any) => obj.hasOwnProperty('issuedDate')) && iDate.includes('T')) {
    //       console.log('masuk ke pengecekan panjang date')
    //       strSplit = dataFormSubmit.value[i].issuedDate.toString().split('T')
    //       dataFormSubmit.value[i].issuedDate = strSplit[0]
    //     }

    //     if (eDate.includes('T')) {
    //       console.log('masuk ke pengecekan expirationDate')
    //       strSplit = dataFormSubmit.value[i].expirationDate.toString().split('T')
    //       dataFormSubmit.value[i].expirationDate = strSplit[0]
    //     }
    //   }
    // }
    // catch (e) {

    // }
    
    try {
      for (let i = 0; i < dataFormSubmit.value.length; i++) {
        uploadFileTemp.value[i] = dataFormSubmit.value[i]?.file ? await processUpload(dataFormSubmit.value[i]?.file?.file) : null
        console.log('mlebu uploadfileTemp', uploadFileTemp.value[i])
        if (uploadFileTemp.value[i]) {
          dataFormSubmit.value[i].fileUrl = uploadFileTemp.value[i] ? `${environment.getApiBaseImageUrl()}${uploadFileTemp.value[i]}` : null
          delete dataFormSubmit.value[i].file
          delete dataFormSubmit.value[i].errorDocumentNumber
          delete dataFormSubmit.value[i].errorIssuedDate
          delete dataFormSubmit.value[i].errorExpirationDate
          delete dataFormSubmit.value[i].errorDocumentFile

          // dataForm.value = [...dataFormSubmit.value]
          // dataForm.value = JSON.parse(JSON.stringify(dataFormSubmit.value))
        }
      }
    } catch (e) {
      console.log('error upload', e)
    }

    console.log(' SUBMIT>>>', dataFormSubmit.value)
    // console.log(' dataForm BIASA>>>', dataForm.value)
    try {
      await apiUseCase.postOrPut(`${employeeEndpoint}/${idPrams.value?.id ?? idPrams.value}/${employeeDocumentBulkEndpoint}`, null, dataFormSubmit.value).then((response) => {
        const {
          error,
          result
        } = response

        if (!error) {
          submitEmployeeContract()
          toast('success', 'Berhasil menyimpan Data Dokumen')
          store.dispatch('employee/setEmployeeFormStep', 4)
        } else if (response.code === 400) {
          toast('error', response.message)
        } else if (response.code === 401) {
          store.dispatch('refreshToken')
        } else {
          toast('error', 'Gagal menyimpan Data Dokumen')
        }
      })
    } catch (error) {
      toast('error', `Gagal menyimpan Data ${error}`)
    }
    store.dispatch('hideLoading')
  } else if (documentRequiredCount.length === 0) {
    submitEmployeeContract()
    store.dispatch('employee/setEmployeeFormStep', 4)
  } else {
    toast('error', 'Pastikan kelengkapan data dokumen wajib')
  }
}

const onSubmit = async (values: any) => {
  console.log('submit', values)
  errorCount.value = 0
  let isDocumentNumberEmpty = []
  deleteObj.value = []

  console.log('dataFormBEFORE', dataForm.value)
  
  try {
    for (let i = 0; i < dataForm.value.length; i++) {
      // console.log('masuuk ', i)
      // console.log('cekkdocNUM ', dataForm.value.some((obj: any) => 'documentNumber' in obj))
      // let documentTypeName = dataForm.value[i].documentTypeName

      errorCount.value = 0
      isDocumentNumberEmpty[i] = true
        // Document Number
        // if (dataForm.value.some((obj: any) => obj.hasOwnProperty('documentNumber'))) {
        //   // console.log('sdfdsfsdadfsaf', dataForm.value[i].documentNumber)
        //   // if (dataForm.value[i].documentNumber === undefined) console.log('wajib diisi')
        //   // dataForm.value[i].error = {}
        //   if (dataForm.value[i].documentNumber === undefined || dataForm.value[i].documentNumber.trim().length === 0) {
        //     console.log('isi dengan nomor yang benar')
            
        //     if (dataForm.value[i].isRequired) {
        //       dataForm.value[i].errorDocumentNumber = 'Tidak Valid'
        //       errorCount.value++
        //     } 
        //     // return
        //   } else {
        //     isDocumentNumberEmpty[i] = false
        //     // cek regex
        //     // if (rgxExp.KTP.test(dataForm.value[i].documentNumber)) {
        //     //   dataForm.value[i].errorDocumentNumber = ''
        //     //   console.log('KTP Valid')
        //     // } else {
        //     //   dataForm.value[i].errorDocumentNumber = 'Tidak Valid'
        //     //   errorCount.value++
        //     //   console.log('KTP Tidak Valid')
        //     //   // return
        //     // }
        //   }
        // } else if (isDocumentNumberEmpty[i] && !dataForm.value[i].isRequired) {
        //   dataForm.value[i].errorDocumentNumber = ''
        // } 
        // else {
        //   dataForm.value[i].errorDocumentNumber = 'Wajib Diisi'
        //   errorCount.value++
        //   // return
        //   // ErrorDocumentNumber.value[i].value = 'DocNumber wajib diisi'
        // }
        // if (issuedDate > expirationDate || issuedDate === expirationDate) {
        //   toast('error', 'Tanggal  Berlaku Sampai harus lebih besar dari Tanggal Dikeluarkan')
        //   return
        // }
        // if (dataForm.value.documentNumber[i].trim().length === 0) console.log('emptyyyy')
        console.log('isDocumentNumberEmpty[i]', isDocumentNumberEmpty)
        
        // if (dataForm.value.some((obj: any) => obj.hasOwnProperty('issuedDate')) && !isDocumentNumberEmpty[i]) {
        //   if (dataForm.value[i].issuedDate === undefined || dataForm.value[i].issuedDate.length === 0 || dataForm.value[i].issuedDate === '') {
        //     console.log('Tanggal Wajib Diisi')
        //     dataForm.value[i].errorIssuedDate = 'Wajib Diisi'
        //     errorCount.value++
        //     return
        //   } else {
        //     dataForm.value[i].errorIssuedDate = ''
        //     // console.log('issueee', moment(dataForm.value[i].issuedDate).format('YYYY-MM-DD'))
        //     let iDate = ''
        //     // iDate = moment(dataForm.value[i].issuedDate.toString()).format('YYYY-MM-DD')
        //     iDate = dataForm.value[i].issuedDate.toISOString().split('T')[0].replace(/-/g, '-')
        //     if (iDate.toString().length > 10) {
        //       console.log('muasuuuukk split iDate')
        //       // const arr = iDate.split('T')
        //       let arr = dataForm.value[i].issuedDate.toISOString().split('T')[0].replace(/-/g, '-')
        //       console.log('muasuuuukk split iDate', arr)
        //       iDate = arr[0]
        //     }
        //     dataForm.value[i].issuedDate = iDate
        //   }
        // } else if (isDocumentNumberEmpty[i] && !dataForm.value[i].isRequired) {
        //   dataForm.value[i].errorIssuedDate = ''
        // } 
        // else {
        //   dataForm.value[i].errorIssuedDate = 'Wajib Diisi'
        //   errorCount.value++
        //   console.log('Tanggal wajib diisi')
        //   // ErrorDocumentNumber.value[i].value = 'Tanggal wajib diisi'
        // }

        // if (dataForm.value.some((obj: any) => obj.hasOwnProperty('expirationDate')) && !isDocumentNumberEmpty[i]) {
        //   if (dataForm.value[i].expirationDate === undefined || dataForm.value[i].expirationDate.length === 0  || dataForm.value[i].expirationDate === '') {
        //     console.log('Tanggal Expired Wajib Diisi')
        //     dataForm.value[i].errorExpirationDate = 'Wajib Diisi'
        //     errorCount.value++
        //     return
        //   } else if (isDocumentNumberEmpty[i]) {
        //     dataForm.value[i].errorExpirationDate = ''
        //   } 
        //   else {
        //     dataForm.value[i].errorExpirationDate = ''
        //     // console.log('expirationDate', moment(dataForm.value[i].expirationDate).format('YYYY-MM-DD'))
        //     let eDate = ''
        //     // eDate = moment(dataForm.value[i].expirationDate.toString()).format('YYYY-MM-DD')
        //     eDate = dataForm.value[i].expirationDate.toISOString().split('T')[0].replace(/-/g, '-')
        //     if (eDate.toString().length > 10) {
        //       console.log('muasuuuukk split eDate')
        //       // const arr = eDate.split('T')
        //       let arrExp = dataForm.value[i].expirationDate.toISOString().split('T')[0].replace(/-/g, '-')
        //       console.log('muasuuuukk split eDate', arrExp)
        //       eDate = arrExp[0]
        //     }
        //     dataForm.value[i].expirationDate = eDate
        //   }
        // } else if (isDocumentNumberEmpty[i] && !dataForm.value[i].isRequired) {
        //   dataForm.value[i].errorExpirationDate = ''
        // } 
        // else {
        //   dataForm.value[i].errorExpirationDate = 'Wajib Diisi'
        //   errorCount.value++
        //   console.log('Tanggal Expired wajib diisi')
        // }

        // if (dataForm.value[i].isRequired && (dataForm.value[i].issuedDate > dataForm.value[i].expirationDate || dataForm.value[i].issuedDate === dataForm.value[i].expirationDate)) {
        //   toast('error', 'Tanggal  Berlaku Sampai harus lebih besar dari Tanggal Dikeluarkan')
        //   errorCount.value++
        //   return
        // }

        // // Image File
        // // if (dataForm.value.some((obj: any) => 'file' in obj)) {
        // if (dataForm.value.some((obj: any) => obj.hasOwnProperty('file')) && !isDocumentNumberEmpty[i]) {
        //   if (dataForm.value[i].file === undefined || dataForm.value[i].file.length === 0) {
        //     dataForm.value[i].errorDocumentFile = 'Wajib Diupload'
        //     errorCount.value++
        //     return
        //   } else {
        //     dataForm.value[i].errorDocumentFile = ''
        //     // console.log('mlebu sblmm', uploadFileTemp[i])
        //     // console.log('mlebu kenee', dataForm.value[i].file)
        //     // fungsi upload image dipindah
        //   }
        // } else if (isDocumentNumberEmpty[i] && !dataForm.value[i].isRequired) {
        //   dataForm.value[i].errorDocumentFile = ''
        // } 
        // else {
        //   dataForm.value[i].errorDocumentFile = 'Wajib Diupload'
        //   errorCount.value++
        //   return
        // }
        // dataForm.value[i].notes = dataForm.value[i].documentTypeName
        // dataForm.value[i].remarks = dataForm.value[i].documentTypeName

        // if (errorCount.value === 0 && !dataForm.value[i].isRequired) {
        //   console.log('massuuukk kosong')
        //   if (dataForm.value[i].documentNumber === undefined || dataForm.value[i].documentNumber.trim().length === 0) {
        //     console.log('massuuukk KOSONG docnumber')
        //     deleteObj.value.push(i)
        //   }
        // }
    }
    console.log('deleteObj', deleteObj)
    console.log('dataFormNOW', dataForm.value)
    

    // for (let i = 0; i < dataForm.value.length; i++) {
    //   // IssuedDate
    //   // let issuedDate = dataForm.value[i].issuedDate
    //   // if (dataForm.value.some((obj: any) => 'issuedDate' in obj)) {

    // }

    // for (let i = 0; i < dataForm.value.length; i++) {
    //   // ExpirationDate
    //   // let expirationDate = dataForm.value[i].expirationDate
    //   // if (dataForm.value.some((obj: any) => 'expirationDate' in obj)) {
    // }
  } catch (e) {
    console.log('error', e)
  }

  processSubmit()

  // if (values.KTPIssuedDate > values.KTPExpirationDate || values.KTPIssuedDate.toString() === values.KTPExpirationDate.toString()) {
  //   toast('error', 'Tanggal KTP Berlaku Sampai harus lebih besar dari Tanggal Dikeluarkan')
  //   return
  // }

  // if (values.KKIssuedDate > values.KKExpirationDate || values.KKIssuedDate.toString() === values.KKExpirationDate.toString()) {
  //   toast('error', 'Tanggal KK Berlaku Sampai harus lebih besar dari Tanggal Dikeluarkan')
  //   return
  // }

  // if (values.SIMIssuedDate > values.SIMExpirationDate || values.SIMIssuedDate.toString() === values.SIMExpirationDate.toString()) {
  //   toast('error', 'Tanggal SIM Berlaku Sampai harus lebih besar dari Tanggal Dikeluarkan')
  //   return
  // }

  // if (values.BPJSDocNumber) {
  //     if (!values.BPJSIssuedDate) {
  //       toast('error', 'Wajib isi Tanggal BPJS Dikeluarkan')
  //       return
  //     }

  //     if (!values.BPJSExpirationDate) {
  //       toast('error', 'Wajib isi Tanggal BPJS Berlaku Sampai')
  //       return
  //     }

  //     if (values.BPJSIssuedDate > values.BPJSExpirationDate || values.BPJSIssuedDate.toString() === values.BPJSExpirationDate.toString()) {
  //       toast('error', 'Tanggal BPJS Berlaku Sampai harus lebih besar dari Tanggal Dikeluarkan')
  //       return
  //     }

  //     if (!values.BPJSPhoto) {
  //       toast('error', 'Harap upload Foto BPJS')
  //     }
  // }

  // if (!values.KTPPhoto || !values.KKPhoto || !values.SIMPhoto) {
  //   toast('error', 'Wajib upload Foto KTP, KK & SIM')
  //   return
  // }

  

  // let KTPPhotoTemp, KKPhotoTemp, SIMPhotoTemp, BPJSPhotoTemp = null
  // if (values.KTPPhoto) {
  //   KTPPhotoTemp = await processUpload(values.KTPPhoto.file)
  // }

  // if (values.KKPhoto) {
  //   KKPhotoTemp = await processUpload(values.KKPhoto.file)
  // } 

  // if (values.SIMPhoto) {
  //   SIMPhotoTemp = await processUpload(values.SIMPhoto.file)
  // } 

  // if (values.BPJSDocNumber) {
  //   if (values.BPJSPhoto) {
  //     BPJSPhotoTemp = await processUpload(values.BPJSPhoto.file)
  //   }
  // }
  // prepareDataForm()

  // dataFormKTP.value = {
  //   'documentNumber': values.KTPDocNumber,
  //   'remarks': 'KTP',
  //   'fileUrl': KTPPhotoTemp ? `${environment.getApiBaseImageUrl()}${KTPPhotoTemp}` : null,
  //   'issuedDate': moment(values.KTPIssuedDate).format('YYYY-MM-DD'),
  //   'expirationDate': moment(values.KTPExpirationDate).format('YYYY-MM-DD'),
  //   'documentTypeId': '01970b07-a1fa-7ab4-8706-1ba87bd5b0a0',
  // }

  // dataFormKK.value = {
  //   'documentNumber': values.KKDocNumber,
  //   'remarks': 'KK',
  //   'fileUrl': KKPhotoTemp ? `${environment.getApiBaseImageUrl()}${KKPhotoTemp}` : null,
  //   'issuedDate': moment(values.KKIssuedDate).format('YYYY-MM-DD'),
  //   'expirationDate': moment(values.KKExpirationDate).format('YYYY-MM-DD'),
  //   'documentTypeId': '0197c4c7-da5b-70f7-8198-b4d0b01f5a31',
  // }

  // dataFormSIM.value = {
  //   'documentNumber': values.SIMDocNumber,
  //   'remarks': 'SIM',
  //   'fileUrl': SIMPhotoTemp ? `${environment.getApiBaseImageUrl()}${SIMPhotoTemp}` : null,
  //   'issuedDate': moment(values.SIMIssuedDate).format('YYYY-MM-DD'),
  //   'expirationDate': moment(values.SIMExpirationDate).format('YYYY-MM-DD'),
  //   'documentTypeId': '01970cc9-e966-7171-954f-a043ec17babe',
  // }

  // dataFormBPJS.value = {
  //   'documentNumber': values.BPJSDocNumber ?? null,
  //   'remarks': values.BPJSDocNumber ? 'BPJS' : null,
  //   'fileUrl': BPJSPhotoTemp ? `${environment.getApiBaseImageUrl()}${BPJSPhotoTemp}` : null,
  //   'issuedDate': values.BPJSIssuedDate ? moment(values.BPJSIssuedDate).format('YYYY-MM-DD') : null,
  //   'expirationDate': values.BPJSExpirationDate ? moment(values.BPJSExpirationDate).format('YYYY-MM-DD') : null,
  //   'documentTypeId': '019734b3-18f6-7422-b3b8-2c7e9f58fd3f',
  // }

  // allDataForm.value = [
  //   dataFormKTP.value,
  //   dataFormKK.value,
  //   dataFormSIM.value,
  // ]

  // values.BPJSDocNumber ? allDataForm.value.push(dataFormBPJS) : null

  
}

const checkEmployeeId = async () => {
  try {
    console.log('employeeid from prev', idPrams.value)
    if (!idPrams.value) idPrams.value = store.getters['employee/getEmployeeId']
    console.log('employeeid after load', idPrams.value)
  } catch (e) {
    console.log(e)
  }
}

const getData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${idPrams.value?.id ?? idPrams.value}`).then((response) => {
    const { error, result } = response
    if (!error) {
      isLoading.value = false
      store.dispatch('employee/setEmployeeData', result)
    } else {
      console.log('error', error)
    }
  })
  store.dispatch('hideLoading')
}

const getPositionDocumentRequirements = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${positionEndpoint}/${dataFormContract.value.positionId}/${documentRequirementsEndpoint}`).then((response) => {
    const { error, result } = response
    if (!error) {
      if (result.length === 0) isDocumentRequirementEmpty.value = true
      else dataForm.value = result
      console.log('success', result.length)
    } else {
      console.log('error', error)
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  try {
    if (route.params.id) {
      idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
    } else {
      isLoading.value = false
    }

    contract.value = store.getters['employee/getEmployeeContractLabel']
    console.log('contractTTT', contract.value)

    checkEmployeeId()
    console.log('id', store.getters['employee/getEmployeeId'])
    if (idPrams.value) getData()

    // console.log('Divisi ALL', store.getters['employee/getEmployeeEmployments'])
    // console.log('positionId', store.getters['employee/getEmployeeEmployments'][0].positionId)
    getPositionDocumentRequirements()
  } catch (e) {
    console.log('error', e)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Card, {
        class: "card-shadow shadow-lg rounded-lg my-8",
        style: {"width":"25rem"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[2] || (_cache[2] = _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "suitcase"
                })
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(`${contract.value.positionName}`), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: "check"
                    })
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(`${contract.value.regionName}`), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(`${_unref(moment)(contract.value.startDate).format('DD MMMM YYYY')} - ${_unref(moment)(contract.value.EndDate).format('DD MMMM YYYY')}`), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-grey-5 px-2" }, "|", -1)),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(`${countDiffDate(contract.value.startDate, contract.value.endDate)}`), 1)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(`${contract.value.employmentTypeName}`), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(`Keterangan: ${contract.value.remarks}`), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "font-bold text-xl mb-8" }, "Dokumen Penting", -1)),
      _createVNode(_unref(Form), {
        onSubmit: onSubmit,
        "validation-schema": _unref(schema),
        "initial-values": initialValues,
        class: "form-container"
      }, {
        default: _withCtx(({ setFieldValue, meta }) => [
          (!isDocumentRequirementEmpty.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "col-span-1 pt-6" }, null, -1),
                _createElementVNode("div", { class: "col-span-2" }, [
                  _createElementVNode("p", { class: "text-sm" }, "Tipe Dokumen")
                ], -1),
                _createElementVNode("div", { class: "col-span-2" }, [
                  _createElementVNode("p", { class: "text-sm" }, "Nomor Dokumen")
                ], -1),
                _createElementVNode("div", { class: "col-span-2" }, [
                  _createElementVNode("p", { class: "text-sm" }, "Tanggal Dikeluarkan")
                ], -1),
                _createElementVNode("div", { class: "col-span-2" }, [
                  _createElementVNode("p", { class: "text-sm" }, "Berlaku Sampai")
                ], -1),
                _createElementVNode("div", { class: "col-span-2" }, [
                  _createElementVNode("p", { class: "text-sm" }, "File Dokumen")
                ], -1)
              ])))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.value, (x, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "grid grid-cols-11 gap-8 ml-min",
              key: i
            }, [
              _createElementVNode("div", _hoisted_13, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-1" }, null, -1)),
                _createElementVNode("ul", _hoisted_14, [
                  _createElementVNode("li", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(i + 1), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: _normalizeClass(x.isRequired ? 'required' : '')
                    }, _toDisplayString(x.documentTypeName), 3)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_unref(Field), {
                      name: `KTPDocNumber-${i}`
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, field }) => [
                        _createVNode(_unref(InputText), _mergeProps({
                          id: "KTPdocNumber",
                          "aria-describedby": "id-ktpdocnumber-help",
                          placeholder: "1234xxx",
                          class: `input-primary ${x.errorDocumentNumber ? 'input-invalid' : ''}`
                        }, { ref_for: true }, field, {
                          modelValue: x.documentNumber,
                          "onUpdate:modelValue": ($event: any) => ((x.documentNumber) = $event),
                          onChange: handleChange,
                          onBlur: handleBlur
                        }), null, 16, ["class", "modelValue", "onUpdate:modelValue", "onChange", "onBlur"])
                      ]),
                      _: 2
                    }, 1032, ["name"]),
                    (x.isRequired)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString('Wajib diisi')))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(x.errorDocumentNumber), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_unref(Field), {
                      name: `KTPIssuedDate-${i}`
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_unref(DatePicker), _mergeProps({ ref_for: true }, field, {
                          modelValue: x.issuedDate,
                          "onUpdate:modelValue": ($event: any) => ((x.issuedDate) = $event),
                          masks: {
                      input: 'DD/MM/YYYY'
                    },
                          "input-debounce": 0
                        }), {
                          default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                            _createVNode(_unref(InputText), _mergeProps({
                              id: `KTPIssuedDate-${i}`,
                              "aria-describedby": "ktp-issuedDate-help",
                              placeholder: "DD/MM/YYYY",
                              value: inputValue,
                              class: `input-primary ${x.errorIssuedDate ? 'input-invalid' : ''}`
                            }, _toHandlers(inputEvents), {
                              onClick: togglePopover,
                              onInput: (e) => onDateInput(e, x, 'issuedDate', `KTPIssuedDate-${i}`, setFieldValue),
                              onChange: (e) => onDateChange(e, x, 'issuedDate', `KTPIssuedDate-${i}`, setFieldValue)
                            }), null, 16, ["id", "value", "class", "onClick", "onInput", "onChange"])
                          ]),
                          _: 2
                        }, 1040, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["name"]),
                    (x.isRequired)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString('Wajib diisi')))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_30, _toDisplayString(x.errorIssuedDate), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_unref(Field), {
                      name: `KTPExpirationDate-${i}`
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_unref(DatePicker), _mergeProps({ ref_for: true }, field, {
                          modelValue: x.expirationDate,
                          "onUpdate:modelValue": ($event: any) => ((x.expirationDate) = $event),
                          masks: {
                      input: 'DD/MM/YYYY'
                    },
                          "input-debounce": 0
                        }), {
                          default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                            _createVNode(_unref(InputText), _mergeProps({
                              id: `KTPExpirationDate-${i}`,
                              "aria-describedby": "ktp-expirationDate-help",
                              placeholder: "DD/MM/YYYY",
                              value: inputValue,
                              class: `input-primary ${x.errorExpirationDate ? 'input-invalid' : ''}`
                            }, _toHandlers(inputEvents), {
                              onClick: togglePopover,
                              onInput: (e) => onDateInput(e, x, 'expirationDate', `KTPExpirationDate-${i}`, setFieldValue),
                              onChange: (e) => onDateChange(e, x, 'expirationDate', `KTPExpirationDate-${i}`, setFieldValue)
                            }), null, 16, ["id", "value", "class", "onClick", "onInput", "onChange"])
                          ]),
                          _: 2
                        }, 1040, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["name"]),
                    (x.documentTypeReminderDaysBeforeExpiry && x.isRequired)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString('Wajib diisi')))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_35, _toDisplayString(x.errorExpirationDate), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_unref(Field), {
                      name: `KTPFileDocument-${i}`
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(ButtonFileUpload, _mergeProps({
                          inputId: `KTPFileDocument-${i}`,
                          size: maxSizeFile
                        }, { ref_for: true }, field, {
                          modelValue: x.file,
                          "onUpdate:modelValue": ($event: any) => ((x.file) = $event),
                          onOnInputFile: (newFile, oldFile) => onInputFile(newFile, x.documentTypeName, setFieldValue, x)
                        }), {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("div", _hoisted_40, [
                                (!x.file)
                                  ? (_openBlock(), _createBlock(_unref(Button), _mergeProps({
                                      key: 0,
                                      class: "btn-back flex gap-x-2 cursor cursor-pointer"
                                    }, { ref_for: true }, field, {
                                      modelValue: x.file,
                                      "onUpdate:modelValue": ($event: any) => ((x.file) = $event)
                                    }), {
                                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                                        _createElementVNode("i", { class: "pi pi-upload font-black text-sm" }, null, -1),
                                        _createTextVNode(" Browse")
                                      ])),
                                      _: 2,
                                      __: [5]
                                    }, 1040, ["modelValue", "onUpdate:modelValue"]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1040, ["inputId", "modelValue", "onUpdate:modelValue", "onOnInputFile"]),
                        (!x.file)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(x.errorDocumentFile), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["name"]),
                    (x.file)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("p", {
                              class: "font-black truncate cursor-pointer",
                              onClick: ($event: any) => (openDetailImg(x.file.blob))
                            }, _toDisplayString(x.file.name), 9, _hoisted_44)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("i", {
                              class: "pi pi-times font-bold color-danger text-sm cursor-pointer",
                              onClick: ($event: any) => (x.file = '')
                            }, null, 8, _hoisted_46)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_unref(Button), {
              type: "submit",
              class: "btn-primary mr-1",
              disabled: (meta.valid && false)
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Lanjut")
              ])),
              _: 2,
              __: [6]
            }, 1032, ["disabled"])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ]))
}
}

})